<template>
  <update-business-member-field
    :value="member.knownAllergies"
    :member="member"
    :is-loading="isLoading"
    @update:isLoading="$emit('update:isLoading', $event)"
    :is-editing="isEditing"
    @update:isEditing="handleIsEditing"
    @save="save"
  >
    <template>
      <base-textarea placeholder="Enter known allergies" v-model="knownAllergies" class="tw-mb-5" />
    </template>
    <template #title>
      <div :class="[{ 'tw-text-red-600': member.knownAllergies }]">Known Allergies</div>
    </template>
    <template #value>
      <div :class="[{ 'tw-text-red-600': member.knownAllergies }]">{{ member.knownAllergies || "-" }}</div>
    </template>
  </update-business-member-field>
</template>

<script>
import UpdateBusinessMemberField from "@/views/business/member/components/UpdateBusinessMemberField";

export default {
  components: {
    UpdateBusinessMemberField,
  },
  props: {
    isLoading: Boolean,
    isEditing: Boolean,
    member: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      knownAllergies: "",
    };
  },
  methods: {
    handleIsEditing($event) {
      this.knownAllergies = this.member.knownAllergies;
      this.$emit("update:isEditing", $event);
    },
    save() {
      this.$emit("updated", {
        ...this.member,
        knownAllergies: this.knownAllergies,
      });
    },
  },
};
</script>
